<template>
  <div class="mm-toast-viewport" aria-live="polite" aria-atomic="true">
    <transition-group name="mm-toast" tag="div" class="mm-toast-stack">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="mm-toast"
        :class="`mm-toast--${t.variant || 'default'}`"
        role="status"
      >
        <component :is="iconFor(t.variant)" class="mm-toast-icon" :size="18" />
        <div class="mm-toast-content">
          <p v-if="t.title" class="mm-toast-title">{{ t.title }}</p>
          <p v-if="t.description" class="mm-toast-desc">{{ t.description }}</p>
        </div>
        <button
          type="button"
          class="mm-toast-close"
          aria-label="Dismiss"
          @click="dismiss(t.id)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-4 w-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/ui/dialog.tsx:46:8" data-component-name="X"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastState, dismiss } from "./toastStore";

export default {
  name: "ToastHost",
  computed: {
    toasts() {
      return toastState.toasts;
    },
  },
  methods: {
    dismiss,
    iconFor(variant) {
      return variant === "destructive" ? "AlertCircle" : "CheckCircle2";
    },
  },
};
</script>

<style scoped>
.mm-toast-viewport {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9999;
  padding: 16px;
  max-height: 100vh;
  width: 100%;
  max-width: 420px;
  pointer-events: none;
}
.mm-toast-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mm-toast {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid #e4e9ec;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.mm-toast--default {
  border-color: #cfe9d4;
  background: #fff;
}
.mm-toast--default .mm-toast-icon {
  color: #009118;
}
.mm-toast--destructive {
  border-color: #ee4200;
  background: #ee4200;
  color: #fff;
}
.mm-toast--destructive .mm-toast-icon {
  color: #fff;
}
.mm-toast-icon {
  flex: 0 0 auto;
  margin-top: 1px;
}
.mm-toast-content {
  flex: 1 1 auto;
  min-width: 0;
}
.mm-toast-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #002f42;
}
.mm-toast-desc {
  margin: 2px 0 0;
  font-size: 13px;
  color: #5b6b73;
  word-break: break-word;
}
.mm-toast--destructive .mm-toast-title,
.mm-toast--destructive .mm-toast-desc {
  color: #fff;
}
.mm-toast-close {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: inherit;
  opacity: 0.6;
  cursor: pointer;
}
.mm-toast-close:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06);
}
.mm-toast--destructive .mm-toast-close:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* enter/leave + reorder animations */
.mm-toast-enter-active,
.mm-toast-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.mm-toast-enter {
  transform: translateX(110%);
  opacity: 0;
}
.mm-toast-leave-to {
  transform: translateX(110%);
  opacity: 0;
}
.mm-toast-leave-active {
  position: absolute;
  right: 16px;
  width: calc(100% - 32px);
}
.mm-toast-move {
  transition: transform 0.25s ease;
}
</style>



// WEBPACK FOOTER //
// src/ToastHost.vue